module.exports = __webpack_public_path__ + "img/hand-holding-water.75d060f6.svg";